"use client";
import React from "react";
import SectionOne from "./SectionOne";

export default function HighlightSection(props) {
  let machine = props.data;
  return (
    <div
      className="highlight-section"
      style={{
        backgroundImage: `url(https://rps-cms-app-public.nyc3.digitaloceanspaces.com/dp_background_one_9d4b596633.png?updated_at=2023-10-02T14:51:36.192Z`,
      }}
    >
      <div className="section-heading">
        <h2 className="title">
          {machine.name} <span>{machine.version} </span>
        </h2>
        <h3>{machine.style.data.attributes.style}</h3>
      </div>
    </div>
  );
}
